/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyContactPersonDto } from './companyContactPersonDto';
import { CompanyProfileResponseDto } from './companyProfileResponseDto';


export interface CompanyDto { 
    did: string;
    companyProfile: CompanyProfileResponseDto;
    invitedBy?: string;
    contactPersons?: Array<CompanyContactPersonDto>;
    status: CompanyDto.StatusEnum;
    /**
     * Credential types the company requested
     */
    requestedCredentialTypes: Array<CompanyDto.RequestedCredentialTypesEnum>;
    /**
     * Flag indicating the company may be a duplicate based on Typesense similarity search
     */
    possibleDuplicate?: boolean;
    /**
     * Verifiable Presentation containing existing identity credentials (e.g., vLEI from GLEIF) for companies with their own IT infrastructure
     */
    existingIdentityPresentation?: object;
}
export namespace CompanyDto {
    export const StatusEnum = {
        Pending: 'pending',
        Approved: 'approved',
        Rejected: 'rejected',
        Revoked: 'revoked'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const RequestedCredentialTypesEnum = {
        GbaFacilityReportIssuer: 'GBAFacilityReportIssuer',
        GbaVerifiedCompany: 'GBAVerifiedCompany',
        GbaApprovedVerifierCredential: 'GBAApprovedVerifierCredential',
        GbaApprovedCertifierCredential: 'GBAApprovedCertifierCredential',
        GbaApprovedCarbonCalculationPartnerCredential: 'GBAApprovedCarbonCalculationPartnerCredential'
    } as const;
    export type RequestedCredentialTypesEnum = typeof RequestedCredentialTypesEnum[keyof typeof RequestedCredentialTypesEnum];
}


